const INSTITUTION_TYPES = {
	INITIAL_STATE: 'INSTITUTIONS/INITIAL_STATE',
	GET_ALL: 'INSTITUTIONS/GET_ALL',
	SET_ALL: 'INSTITUTIONS/SET_ALL',
	GET_ONE: 'INSTITUTIONS/GET_ONE',
	SET_ONE: 'INSTITUTIONS/SET_ONE',
	CREATE: 'INSTITUTIONS/CREATE',
	UPDATE: 'INSTITUTIONS/UPDATE',
	REMOVE: 'INSTITUTIONS/REMOVE',
	ASSIGN_COURSES: 'INSTITUTIONS/ASSIGN_COURSES',
};

export default INSTITUTION_TYPES;
